import $ from 'cheerio';
import { elementMutatorFactory } from './element-mutator';
export const postProcessHtmlFactory = () => {
    return {
        elements: ['p', 'div', 'h1', 'h2', 'h3'],
        mutators: [
            elementMutatorFactory(($el) => {
                const maxLineHeight = Math.max(...[
                    $el.css('line-height'),
                    ...$el
                        .find('span,p,div,h1,h2,h3')
                        .map((_, el) => $(el).css('line-height'))
                        .get(),
                ].map((lineHeight) => parseInt(lineHeight, 10)));
                $el.css('line-height', `${maxLineHeight}px`);
            }),
        ],
    };
};
//# sourceMappingURL=post-process-html.js.map